import React, { Fragment, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayView } from '@react-google-maps/api';
import {
    setDetailView, visibleAssetsMarkersSelector, detailViewSelector,
    selectVehicleById
} from '../../../features/assets/assetsSlice';

import {
    setCenter, setZoom, mapControlSelector, zoomSelector
} from '../../../features/map/mapSlice';
const offsetx = 100;
const offsety = 0;
const VehicleIcon = ({ assetId }) => {
    const dispatch = useDispatch();
    const mapControl = useSelector(mapControlSelector);
    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const detailView = useSelector(detailViewSelector);
    const zoom = useSelector(zoomSelector);
    const visible = visibleAssetMarkers.indexOf(assetId) !== -1;

    // Get asset data with entity adapter selector
    const assetData = useSelector(state => selectVehicleById(state, assetId) ?? {});
    const { vehicleDevice = {}, coreData = {}, statusMeta = {} } = assetData;
    let lat = 23.5251;
    let lng = 77.8081;
    let heading = 180;

    if (coreData) {
        lat = coreData.lat;
        lng = coreData.lng;
        heading = coreData.heading;
    }
    const setOffsetCenter = useCallback(
        () => {
            if (window.googlemap && window.google) {
                if (window.googlemap.getProjection()) {
                    const scale = Math.pow(2, window.googlemap.getZoom());
                    const latlng = new window.google.maps.LatLng(lat, lng);
                    const worldCoordinateCenter = window.googlemap.getProjection().fromLatLngToPoint(latlng);
                    const pixelOffset = new window.google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);
                    const worldCoordinateNewCenter = new window.google.maps.Point(
                        worldCoordinateCenter.x - pixelOffset.x,
                        worldCoordinateCenter.y + pixelOffset.y
                    );
                    const newCenter = window.googlemap.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
                    window.googlemap.setCenter(newCenter);
                }
            }
        },
        [lat, lng],
    );
    useEffect(() => {
        if (detailView === assetId) {
            //adjust offset center as map is being zoomed in
            setOffsetCenter()
        }
    }, [zoom, detailView, assetId, setOffsetCenter])
    useEffect(() => {
        if (detailView === assetId && mapControl === 'asset') {
            dispatch(setCenter({ lat, lng }));
        }
    }, [detailView, assetId, lat, lng, dispatch, mapControl]);

    useEffect(() => {
        if (detailView === assetId && mapControl === 'asset') {
            dispatch(setZoom(17));
        }

    }, [detailView, dispatch, assetId, mapControl]);



    //let { lat, lng, heading } = coreData;


    const iconClickHandler = (e) => {
        //console.log("Icon click", assetId, e);
        e.stopPropagation();
        //dispatch(setMapControl('asset'));
        dispatch(setDetailView(assetId));
    }






    // Return null if any object is empty
    if (Object.keys(vehicleDevice).length === 0 ||
        Object.keys(coreData).length === 0 ||
        Object.keys(statusMeta).length === 0) {
        return null;
    }

    if (visible) {

        //console.log("Vehicle overlay", vehicleDevice, coreData, statusMeta, visible);
        if (vehicleDevice && coreData && statusMeta) {
            const { regn, icon } = vehicleDevice;
            const { colorbg, colorfg } = statusMeta;

            return (
                <OverlayView
                    position={{ lat, lng }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <Fragment>
                        <img
                            src={`/assets/markers/def30/${icon}`}
                            alt={regn}
                            style={{
                                transform: `rotate(${heading}deg)`,
                                display: 'inline-block',
                                position: 'absolute',
                                left: -7,
                                top: -15,
                            }}
                            onClick={iconClickHandler}
                        />
                        {/*<Chip
                            size="small"
                            style={{
                                backgroundColor: colorbg,
                                position: 'absolute',
                                left: -0,
                                top: 20,
                            }}
                            label={
                                <span style={{ color: colorfg }}>{regn}</span>
                            }
                        />*/}
                        <div style={{
                            backgroundColor: colorbg,
                            position: 'absolute',
                            left: -0,
                            top: 20,
                            whiteSpace: 'nowrap',
                            borderRadius: '2px',
                        }}>
                            <span style={{ color: colorfg, fontSize: 11 }}>&nbsp;<b>{regn}</b>&nbsp;</span>
                        </div>
                    </Fragment>

                </OverlayView>
            );
        } else {
            //console.log("Data not ready");
            return null;
        }
    }
    else {
        //console.log("Not Visible");
        return null;
    }


}

export default React.memo(VehicleIcon);

